import NoOwnerCode from "./NoOwnerCode";
export default NoOwnerCode;
